import axios from "axios";

const API_BASE_URL = "https://admin.thedpboss.com/api/v1/";

export const placeBids = async (endpoint, body) => {
  try {
    const token = localStorage.getItem("accessToken");   

    if (!token) {
      console.error("No token found");
      return { status: false, msg: "Authentication required" };   
    }

    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",                
      "Content-Type": "application/json",
    };

    const fullApiUrl = `${API_BASE_URL}${endpoint}`;

    console.log("Submitting:", fullApiUrl, body);

    const response = await axios.post(fullApiUrl, body, { headers });

    return response.data;
  } catch (error) {
    console.error("API Error:", error?.response || error);
    return {
      status: false,
      msg:
        error.response?.data?.msg ||
        "Network error. Please try again later.",
    };
  }
};